export default {"src":"/_next/static/media/energyLogo1.a999f3e7.svg","height":48,"width":272,"blurWidth":0,"blurHeight":0};